import { Component, inject } from '@angular/core';
import { DataService } from '../../services/data/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { companies, companiesFinanciero, companiesReportesNorm, companiesRiesgoCredito, companiesRiesgoCreditoAT, companiesRiesgoLiquidez, companiesSegPresupuestal } from '../../shared/catalogos';
import { firstValueFrom } from 'rxjs';
import { ContenedorService } from '../../services/contenedor/contenedor.service';
import { ArraysOrder } from '../funciones/funcionesGenerales';
import { messages } from '../funciones/mensajes';
import { Apollo } from 'apollo-angular';
import { SecureCookiesService } from '../../services/encript/secure-cookies.service';
import { HttpHeaders } from '@angular/common/http';
import { getAsignacionesInst, getCuestionarioPorId, getEstatusHoja, getHojaRespuesta } from '../../services/Administrador/cuestionarios/query';
import { environment } from '../../../environments/environment';
import { PlanificacionService } from '../../services/gestion/planificacion/planificacion.service';
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css'
})
export class MenuComponent {
  arrowState = [];

  ejemploEmpty = [];
  private eliminar = false;

  private access = [];
  private url: any;
  public planning = [];
  private planingId = 0;
  private selectPlannig: any = ''

  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  public allocations: any[] = [];

  dataService = inject(DataService);
  #router = inject(Router);
  #translate = inject(TranslateService);
  #apollo = inject(Apollo);
  #secureCookies = inject(SecureCookiesService);

  constructor(
    private cookies: CookieService,
    private rutaActual: ActivatedRoute,
    private contenedorService: ContenedorService,
    private activeRoute: ActivatedRoute,
    private planificacionService: PlanificacionService,
  ) {
    this.dataService.modulesUser.forEach(mod => {
      this.arrowState.push('keyboard_arrow_down');
    });
  }
  public isFirstModule(pos) {
    if (pos === 0) {
      return true
    } else if (this.dataService.modulesUser[pos].platform !== this.dataService.modulesUser[pos - 1].platform) {
      return true;
    }
    return false;
  }

  removeAccents(text) {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  isActivateModule(menu) {
    const route = this.#router.url;
    const splitRoute = route.split('/');
    splitRoute.shift();
    splitRoute.shift();

    const moduleActive = this.dataService.modulesUser.find(mod =>
      this.removeAccents(mod['name']) === this.removeAccents(menu.name)
      && splitRoute[0] === this.removeAccents(menu['module']).toLowerCase()
    );

    if (moduleActive) {
      this.dataService.moduleSelect = moduleActive.name;
      return true;
    } else {
      return false;
    }
  }

  public isActiveSubmodule(submenu) {
    let route = this.#router.url;
    const splitRoute = route.split('/');
    splitRoute.shift();
    splitRoute.shift();
    if (!!Number(route[splitRoute.length - 1])) {
      splitRoute.pop();
    }
    const rutas2 = [splitRoute[0], splitRoute[splitRoute.length - 1]];
    route = rutas2.join('/');
    if (submenu['route'] === route) {
      this.dataService.subModuleSelect = submenu['name'];
      return true;
    } else {
      return false;
    }
  }

  sendTo(route) {
    const ruta = this.rutaActual.snapshot['url'];
    const mod = route.route.split('/')[0];
    const submodulo = route.route.split('/')[1];
    const currentSubmodule = ruta.length > 2 ? ruta[2].path : '';

    if (mod === 'operative' || mod === 'operative-potencial') {
      if (ruta.length === 1 || ruta[1].path !== 'operative' && ruta[1].path !== 'operative-potencial') {
        this.eliminar = true;
      }
      localStorage.removeItem('cuestionario');
      localStorage.removeItem('answers');
      localStorage.removeItem('allocation');
      this.cookies.delete('idPlanFin', '/');
      this.cookies.delete('nombreInstitucion', '/');
      this.sendToOperative(route);
    } else if (mod === 'riesgo-credito') {
      if (ruta.length === 1 || (ruta[1].path !== 'riesgo-credito')) {
        this.eliminar = true;
      }
      localStorage.removeItem('cuestionario');
      localStorage.removeItem('answers');
      localStorage.removeItem('allocation');
      this.cookies.delete('idPlanFin', '/');
      this.cookies.delete('nombreInstitucion', '/');
      this.sendToRiesgoCredito(route);
    } else if (mod === 'financiero-alerta') {
      if (ruta.length === 1 || (ruta[1].path !== 'financiero-alerta')) {
        this.eliminar = true;
      }
      localStorage.removeItem('cuestionario');
      localStorage.removeItem('answers');
      localStorage.removeItem('allocation');
      this.cookies.delete('nombreInstitucion', '/');
      this.sendToFinancieroAlerta(route);
    } else if (mod === 'formulacion' || mod === 'seguimiento' || mod === 'reportes') {
      if (ruta.length === 1 || (ruta[1].path !== 'formulacion' && ruta[1].path !== 'seguimiento' && ruta[1].path !== 'reportes')) {
        this.eliminar = true;
      }
      localStorage.removeItem('cuestionario');
      localStorage.removeItem('answers');
      localStorage.removeItem('allocation');
      this.cookies.delete('idPlanFin', '/');
      this.sendToGestionEstrategica(route);
    } else if (mod === 'cuestionarios' || mod === 'resultados' || mod === 'clima-laboral') {
      if (route.module !== 'resultados' && route.module !== 'clima-laboral') {
        this.#router.navigateByUrl('app/' + route.route);
      } else if(route.module === 'clima-laboral'){
        if(ruta.length === 1 || ( ruta[1].path !== 'clima-laboral') ){
          this.eliminar = true;
        }
        this.sendToClimaLaboral(route);
      } else {
        if(ruta.length === 1 || ( ruta[1].path !== 'resultados') ){
          this.eliminar = true;
        }
        this.sendToResults(route);
      }
    }else if(mod === 'proyecciones-financieras'){
      if(ruta.length === 1 || ( ruta[1].path !== 'proyecciones-financieras') ){
        this.eliminar = true;
      }
      localStorage.removeItem('cuestionario');
      localStorage.removeItem('answers');
      localStorage.removeItem('allocation');
      this.sendToProyecciones(route);
    } else if (mod === 'reportes-normativos'){
      if(ruta.length === 1 || ( ruta[1].path !== 'reportes-normativos') ){
        this.eliminar = true;
      }
      localStorage.removeItem('cuestionario');
      localStorage.removeItem('answers');
      localStorage.removeItem('allocation');
      this.sendToReportesNorm(route);
    } else if(mod === 'seguimiento-presupuestal'){
      if(ruta.length === 1 || ( ruta[1].path !== 'seguimiento-presupuestal') ){
        this.eliminar = true;
      }
      this.sendToSegPresupuestal(route);
    } else if (mod === 'administrador-gestion') {
      const isFromDifferentModule = ruta.length === 1 || ruta[1].path !== 'administrador-gestion';
      const isEnteringCatalogos = submodulo === 'catalogos' && currentSubmodule !== 'catalogos';
      const isLeavingAltaPlanes = currentSubmodule === 'alta-planes' && submodulo !== 'alta-planes';

      if (isFromDifferentModule || isEnteringCatalogos) {
        this.eliminar = true;
      }

      // Manejo especial para salida de alta-planes
      if (isLeavingAltaPlanes) {
        this.cookies.delete('idInstitucion', '/');
        this.cookies.delete('nombreInstitucion', '/');
        this.eliminar = true;
      }

      // Manejo especial para alta-planes
      if (submodulo === 'alta-planes') {
        this.cookies.delete('idInstitucion', '/');
        this.cookies.delete('nombreInstitucion', '/');
        this.cookies.set('nombreInstitucion', "Planeaciones", { path: '/' });
      }

      localStorage.removeItem('cuestionario');
      localStorage.removeItem('answers');
      localStorage.removeItem('allocation');
      this.cookies.delete('idPlanFin', '/');
      this.sendToGestionEstrategica(route);
    }//TODO: alta de planes (caso especial submodulo)
    else if (mod == 'riesgo-liquidez') {
      if (ruta.length === 1 || (ruta[1].path != 'riesgo-liquidez')) {
        this.eliminar = true;
      }
      localStorage.removeItem('cuestionario');
      localStorage.removeItem('answers');
      localStorage.removeItem('allocation');
      this.cookies.delete('idPlanFin', '/');
      this.cookies.delete('nombreInstitucion', '/');
      this.sendToRiesgoLiquidez(route);
    }else {
      localStorage.removeItem('cuestionario');
      localStorage.removeItem('answers');
      localStorage.removeItem('allocation');
      this.cookies.delete('idInstitucion', '/');
      this.cookies.delete('idPlanFin', '/');
      this.#router.navigateByUrl('app/' + route.route);
    }
  }
  // Envio plataforma operativo
  async sendToOperative(route) {
    if (this.dataService.role.toLowerCase().includes('administrador')) {
      if (this.cookies.get('idInstitucion') === '' || this.eliminar) {
        var inst = [];
        for (const c of companies) {
          inst.push(c.name)
        }

        const result = await messages.select(
          this.#translate.instant('swal.seleccione-institucion'),
          inst,
          this.#translate
        );
        if (result) {
          this.cookies.delete('idInstitucion', '/');
          this.cookies.delete('idPlanFin', '/');
          this.cookies.set('idInstitucion', companies[result].id, { path: '/' });
          this.#router.navigateByUrl('/app/' + route.route);
        }
        this.eliminar = false;
      } else {
        this.#router.navigateByUrl('/app/' + route.route);
      }
    } else {
      if (this.cookies.get('idInstitucion') === '' || this.eliminar) {
        this.cookies.delete('idPlanFin', '/');
        this.cookies.delete('idInstitucion', '/');
        this.cookies.set('idInstitucion', this.dataService.idInstitution, { path: '/' });
        this.eliminar = false;
      }
      this.#router.navigateByUrl('/app/' + route.route);
    }
  }
  // Envio plataforma de riesgos
  async sendToRiesgoCredito(route) {
    if (this.dataService.role.toLowerCase().includes('administrador')) {
      if (this.cookies.get('idInstitucion') === '' || this.eliminar) {
        var inst = [];
        for (const c of companiesRiesgoCredito) {
          inst.push(c.name)
        }

        const result = await messages.select(
          this.#translate.instant('swal.seleccione-institucion'),
          inst,
          this.#translate
        );
        if (result) {
          this.cookies.delete('idInstitucion', '/');
          this.cookies.delete('idPlanFin', '/');
          this.cookies.set('idInstitucion', companiesRiesgoCredito[result].id, { path: '/' });
          this.#router.navigateByUrl('/app/' + route.route);
        }
        this.eliminar = false;
      } else {
        this.#router.navigateByUrl('/app/' + route.route);
      }
    } else {
      if (this.cookies.get('idInstitucion') === '' || this.eliminar) {
        this.cookies.delete('idPlanFin', '/');
        this.cookies.delete('idInstitucion', '/');
        this.eliminar = false;
        const ex = companiesRiesgoCredito.find(c => c.idAdmin === this.dataService.idInstitution);
        if (ex) {
          this.cookies.set('idInstitucion', ex.id, { path: '/' });
          this.eliminar = false;
        }
      }
      this.#router.navigateByUrl('/app/' + route.route);
    }
  }
  async sendToFinancieroAlerta(route) {
    if (this.dataService.role.toLowerCase().includes('administrador')) {
      if (this.cookies.get('idInstitucion') === '' || this.eliminar) {
        var inst = [];
        for (const c of companiesFinanciero) {
          inst.push(c.name)
        }

        const result = await messages.select(
          this.#translate.instant('swal.seleccione-institucion'),
          inst,
          this.#translate
        );
        if (result) {
          this.cookies.delete('idInstitucion', '/');
          this.cookies.delete('idPlanFin', '/');
          this.cookies.set('idInstitucion', companiesFinanciero[result].id, { path: '/' });
          this.cookies.set('idPlanFin', companiesFinanciero[result].idPlantilla, { path: '/' });
          this.#router.navigateByUrl('/app/' + route.route);
        }
        this.eliminar = false;
      } else {
        this.#router.navigateByUrl('/app/' + route.route);
      }
    } else {
      if (this.cookies.get('idInstitucion') === '' || this.eliminar) {
        this.cookies.delete('idInstitucion', '/');
        this.cookies.delete('idPlanFin', '/');
        const ex = companiesFinanciero.find(c => c.idAdmin === this.dataService.idInstitution);
        if (ex) {
          this.cookies.set('idInstitucion', ex.id, { path: '/' });
          this.cookies.set('idPlanFin', '' + ex.idPlantilla, { path: '/' });
          this.eliminar = false;
        }
      }
      this.#router.navigateByUrl('/app/' + route.route);
    }
  }
  // Envio plataforma gestion
  async sendToGestionEstrategica(route) {
    await this.getAccess();
    if (route.module !== 'administrador-gestion' && this.eliminar) {
      messages.messageSaving(this.#translate.instant('acciones.espera'), '');
      const res = await this.planificacionService.getPlanificacionesGQLMenu();

      this.planning = [];
      for (const plan of res) {
        if (this.planAccess(plan.institution.id)) {
          this.planning.push({
            id: plan.id,
            name: plan.name,
          });
        }
      }
      this.planning = ArraysOrder.orderNumber(this.planning, 'id')
      var plans: any = [];
      for (const plan of this.planning) {
        plans.push(`${plan.name}`);
      }
      Swal.close();
      if (plans.length > 0) {
        const result = await messages.select(
          this.#translate.instant('gestion.seleccione-planeacion'),
          plans,
          this.#translate
        );
        if (result) {
          this.planingId = Number(this.planning[Number(result)].id);
          this.selectPlannig = this.planning[Number(result)].name;

          this.cookies.set('idInstitucion', `${this.planingId}`, { path: '/' });
          this.cookies.set('nombreInstitucion', this.selectPlannig, { path: '/' });
          this.#router.navigateByUrl(`app/${route.route}`);
        }
      } else {
        messages.infoMessageGraph(this.#translate.instant('gestion.institucion-no-encontrada'));
      }
    } else if (route.module === 'administrador-gestion' && this.eliminar && route.name !== 'alta-planes') {
      try {
        messages.messageSaving(this.#translate.instant('acciones.espera'), '');
        const response = await firstValueFrom(this.contenedorService.getInstitutions());
        this.planning = [];
        for (const inst of response) {
          if (this.planAccess(inst.id) && (inst.code === this.dataService.idInstitution || this.dataService.role === 'Administrador')) {
            this.planning.push({
              id: inst.id,
              nombre: inst.name,
            });
          }
        }
        this.planning = ArraysOrder.orderNumber(this.planning, 'id');

        var Planeaciones: any = [];
        for (const plan of this.planning) {
          Planeaciones.push(`${plan.nombre}`);
        }

        Swal.close();
        if (Planeaciones.length > 0) {
          const result = await messages.select(
            this.#translate.instant('swal.seleccione-institucion'),
            Planeaciones,
            this.#translate
          );
          if (result) {
            this.planingId = Number(this.planning[Number(result)].id);
            this.selectPlannig = this.planning[Number(result)].nombre;

            this.cookies.set('idInstitucion', `${this.planingId}`, { path: '/' });
            this.cookies.set('nombreInstitucion', this.selectPlannig, { path: '/' });
            this.#router.navigateByUrl(`app/${route.route}`);
          }
        } else {
          messages.infoMessageGraph(this.#translate.instant('gestion.institucion-no-encontrada'));
        }
      } catch (error) {
        messages.errorMessageGraph('Error al obtener las instituciones');
      }
    } else {
      this.#router.navigateByUrl(`app/${route.route}`);
    }
  }
  // Envio plataforma proyecciones
  async sendToProyecciones(route){
    this.#router.navigateByUrl(`app/${route.route}`);
  }
  // Envio plataforma reportes normativos
  async sendToReportesNorm(route){
    if (this.dataService.role.toLowerCase().includes('administrador')) {
      if (this.cookies.get('idInstitucion') === '' || this.eliminar) {
        var inst = [];
        for (const c of companiesReportesNorm) {
          inst.push(c.name)
        }
        const result = await messages.select(
          this.#translate.instant('swal.seleccione-institucion'),
          inst,
          this.#translate
        );
        if (result) {
          this.cookies.delete('idInstitucion', '/');
          this.cookies.delete('idPlanFin', '/');
          this.cookies.set('idInstitucion', companiesReportesNorm[result].id, { path: '/' });
          this.cookies.set('idPlanFin', companiesReportesNorm[result].idPlantilla, { path: '/' });
          this.#router.navigateByUrl('/app/' + route.route);
        }
        this.eliminar = false;
      } else {
        this.#router.navigateByUrl('/app/' + route.route);
      }
    } else {
      if (this.cookies.get('idInstitucion') === '' || this.eliminar) {
        this.cookies.delete('idInstitucion', '/');
        this.cookies.delete('idPlanFin', '/');
        const ex = companiesReportesNorm.find(c => c.idAdmin === this.dataService.idInstitution);
        if (ex) {
          this.cookies.set('idInstitucion', ex.id, { path: '/' });
          this.cookies.set('idPlanFin', '' + ex.idPlantilla, { path: '/' });
          this.eliminar = false;
        }
      }
      this.#router.navigateByUrl('/app/' + route.route);
    }  }
  // Envio plataforma seguimiento presupuestal
  async sendToSegPresupuestal(route){
    if (this.dataService.role.toLowerCase().includes('administrador')) {
      const idInstitucionCookie = this.cookies.get('idInstitucion');
      if (idInstitucionCookie === '' || this.eliminar) {
        var inst = [];
        for (const c of companiesSegPresupuestal) {
          inst.push(c.name)
        }
        const result = await messages.select(
          this.#translate.instant('swal.seleccione-institucion'),
          inst,
          this.#translate
        );
        if (result) {
          this.cookies.set('idInstitucion', companiesSegPresupuestal[result].id, { path: '/' });
          this.#router.navigateByUrl('/app/' + route.route);
        }
        this.eliminar = false; 
      } else {
        this.#router.navigateByUrl('/app/' + route.route);
      }
    } else {
      this.#router.navigateByUrl('/app/' + route.route);
    }
  }
  private async getAccess() {
    const res = await firstValueFrom(
      this.contenedorService.getAccess(this.dataService.user)
    );

    if (res) {
      this.access = [];
      for (const acc of res.access) {
        this.access.push(`${acc}`);
      }
      if (res.access.length === 0) {
        this.access = ['all']
      }
    } else {
      this.access = ['no encontrado']
    }
    this.url = this.activeRoute.snapshot['url'];
    var params = this.activeRoute.snapshot['params'];
    if (this.url.length !== 1 && this.url.length !== 0) {
      this.planingId = params['idPlanning'];
      this.selectPlannig = params['namePlanning'];
    }
  }
  private planAccess(id: any) {
    if (this.access[0] === 'all' || this.access.includes(id) || this.access[0] === 'no encontrado') {
      return true;
    }
    return false;
  }
  //envio plataforma resultados
  private async sendToResults(route) {
    if(this.eliminar){
      localStorage.removeItem('cuestionario');
      localStorage.removeItem('answers');
      localStorage.removeItem('allocation');
      this.eliminar = false;
    }
    const c = localStorage.getItem('cuestionario') !== null && localStorage.getItem('allocation') !== null;
    if (c) {
      this.#router.navigateByUrl('app/' + route.route);
    } else {
      this.getInformation(route);
    }
  }
  private async getInformation(modulo) {
    messages.messageSaving(this.#translate.instant('acciones.espera'), '')
    try {
      const allocations = await firstValueFrom(
        this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getAsignacionesInst,
          context: { headers: this.headers, },
        }).valueChanges.source
      );

      const arrayAllocations = allocations.data.availableSurveys;
      this.allocations = [];
      var nameAlloc = [];
      for (const all of arrayAllocations) {
        if (this.dataService.role === 'Rol_Administrador_cuestionarios' || all.institution_id === this.dataService.idInstitution) {
          try {
            const answerSheet = await firstValueFrom(
              this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
                query: getEstatusHoja,
                context: { headers: this.headers, },
                variables: { allocationId: Number(all.id) },
                fetchPolicy: 'no-cache',
              }).valueChanges.source
            );

            if (answerSheet.data.findAnswerSheet.status === 'completed' || all.status === 'closed') {
              this.allocations.push(all);
              nameAlloc.push(all.questionary.name);
            }

          } catch (err) { }
        }
      }
      var guardo = false;

      if (this.allocations.length === 0) {
        Swal.close();
        setTimeout(() => {
          messages.infoMessageGraph(this.#translate.instant('cues.resultados.no-informacion'));
        }, 100);
        return;
      }

      const result = await messages.select(
        this.#translate.instant('acciones.seleccione-cuestionario'),
        nameAlloc,
        this.#translate
      );
      if (result) {
        this.cookies.set('nombreInstitucion', nameAlloc[result], { path: '/' });
        guardo = true;
      }

      if (guardo) {
        messages.messageSaving(this.#translate.instant('acciones.espera'), this.#translate.instant('acciones.cargando'))
        try {
          const res = await firstValueFrom(
            this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
              query: getHojaRespuesta,
              context: { headers: this.headers, },
              variables: { allocationId: Number(this.allocations[result].id) }
            }).valueChanges.source
          );

          var answersSheet = [];
          for (const r of res.data.findAnswerSheet.answers) {
            answersSheet.push({ idQuestion: r.question.id, idAnswer: r.answerOption.id })
          }

          const res2 = await firstValueFrom(
            this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
              query: getCuestionarioPorId,
              context: { headers: this.headers, },
              fetchPolicy: 'no-cache',
              variables: {
                args: {
                  relations: {
                    loadRelations: "FULL"
                  },
                  filter: {
                    operator: "AND",
                    conditions: [
                      {
                        field: "id",
                        operator: "EQUAL",
                        value: this.allocations[result].questionary.id
                      }
                    ]
                  },
                },
              }
            }).valueChanges.source
          );

          localStorage.setItem('answers', JSON.stringify(answersSheet));
          localStorage.setItem('allocation', JSON.stringify(this.allocations[result]));
          localStorage.setItem('cuestionario', JSON.stringify(res2.data.questionnaires[0]));
          Swal.close();

          this.#router.navigateByUrl('/app/' + modulo.route);


        } catch (err) {
          messages.errorMessageGraph(err);
        }
      }
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  /** Envio a cuestionarios de multiples respuestas */
  private async sendToClimaLaboral(route){
    if(this.eliminar){
      localStorage.removeItem('cuestionario');
      localStorage.removeItem('answers');
      localStorage.removeItem('allocation');
      this.eliminar = false;
    }
    const c = localStorage.getItem('cuestionario') !== null && localStorage.getItem('allocation') !== null;
    if (c) {
      this.#router.navigateByUrl('app/' + route.route);
    } else {
      this.getCuestionarios(route);
    }
  }
  private async getCuestionarios(modulo){
    messages.messageSaving(this.#translate.instant('acciones.espera'), '')
    try{
      const allocations = await firstValueFrom(
        this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getAsignacionesInst,
          context: { headers: this.headers, },
          fetchPolicy: 'no-cache',
        }).valueChanges.source
      );
      const arrayAllocations = allocations.data.availableSurveys;
      this.allocations = [];
      var nameAlloc = [];
      for(const all of arrayAllocations){
        //los cuestionarios de encuestas de ambiente y clima laboral no se muestran en este modulo(clima laboral)
        //caso especial para el rol Administrador_Planeacion_ClimaLaboral que puede ver todos los cuestionarios de clima laboral
        //aplica en menu.component, inicio.component y contenedor.component
        if(
          (this.dataService.role === 'Administrador_AleemaRemake' || this.dataService.role==='Administrador_Planeacion_ClimaLaboral' || all.institution_id === this.dataService.idInstitution) &&
          all.questionary.allowMultipleAnswers && all.status === 'closed' && !all.questionary.name.toLowerCase().includes('encuesta de ambiente y clima laboral')){
          try{
            this.allocations.push(all);
            nameAlloc.push(all.questionary.name);
    
          }catch(err){}
        }
      }
      var guardo = false;
      if(this.allocations.length === 0){
        Swal.close();
        setTimeout(() =>{
          messages.infoMessageGraph( this.#translate.instant('cues.resultados.no-informacion') );
        }, 100);
        return;
      }

      const result = await messages.select(
        this.#translate.instant('acciones.seleccione-cuestionario'),
        nameAlloc,
        this.#translate
      );
      if (result) {
        this.cookies.set('nombreInstitucion',nameAlloc[result], {path: '/'});
        guardo = true; this.cookies.delete('idInstitucion', '/');
      }
      
      if(guardo){
        messages.messageSaving(this.#translate.instant('acciones.espera'),this.#translate.instant('acciones.cargando'))
        try{
          //TODO: Traer hojas de respuesta
          // const res = await firstValueFrom(
          //   this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
          //     query: getHojaRespuesta,
          //     context: { headers: this.headers, },
          //     variables: { allocationId: Number(this.allocations[inputValue.value].id) }
          //   }).valueChanges.source
          // );
    
          // var answersSheet = [];
          // for(const r of res.data.findAnswerSheet.answers){
          //   answersSheet.push({idQuestion: r.question.id, idAnswer: r.answerOption.id})
          // }
    
          const res2 = await firstValueFrom(
            this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
              query: getCuestionarioPorId,
              context: { headers: this.headers, },
              fetchPolicy: 'no-cache',
              variables: {
                args: {
                  relations: {
                    loadRelations: "FULL"
                  },
                  filter: {
                    operator: "AND",
                    conditions: [
                      {
                        field: "id",
                        operator: "EQUAL",
                        value: ""+this.allocations[result].questionary.id
                      }
                    ]
                  },
                },
              }
            }).valueChanges.source
          );
          // localStorage.setItem('answers', JSON.stringify(answersSheet));
          localStorage.setItem('allocation', JSON.stringify(this.allocations[result]));
          localStorage.setItem('cuestionario', JSON.stringify(res2.data.questionnaires[0]));

          Swal.close();

          this.#router.navigateByUrl('/app/' + modulo.route);  
        }catch(err){
          messages.errorMessageGraph(err);
        }
      }
    }catch(err){
      messages.errorMessageGraph(err)
        }
  }
  // Envio plataforma riesgo-liquidez
  async sendToRiesgoLiquidez(route) {
      if (this.dataService.role.toLowerCase().includes('administrador')) {
          const idInstitucionCookie = this.cookies.get('idInstitucion');
          if (idInstitucionCookie === '' || this.eliminar) {
              var inst = [];
              for (const c of companiesRiesgoLiquidez) {
                  inst.push(c.name)
              }

              const result = await messages.select(
                this.#translate.instant('swal.seleccione-institucion'),
                inst,
                this.#translate
              );
              if (result) {
                this.cookies.delete('idInstitucion', '/');
                this.cookies.delete('idPlanFin', '/');
                this.cookies.set('idInstitucion', companiesRiesgoLiquidez[result].id, { path: '/' });
                this.cookies.set('idPlanFin', companiesRiesgoLiquidez[result].idPlantilla, { path: '/' });
                this.#router.navigateByUrl('/app/' + route.route);
              }
              this.eliminar = false; 
          } else {
              this.#router.navigateByUrl('/app/' + route.route);
          }
      } else {
          const idInstitucionCookie = this.cookies.get('idInstitucion');
          if (idInstitucionCookie === '' || this.eliminar) {
              this.cookies.delete('idInstitucion', '/');
              this.cookies.delete('idPlanFin', '/');
              
              const ex = companiesRiesgoLiquidez.find(c => c.idAdmin === this.dataService.idInstitution);

              if (ex) {
                  this.cookies.set('idInstitucion', ex.id, { path: '/' });
                  this.cookies.set('idPlanFin', '' + ex.idPlantilla, { path: '/' });
                  this.eliminar = false;
              } else {
              }
          } else {
          }
          
          this.#router.navigateByUrl('/app/' + route.route);
      }
  }
}
